import { memo, useState } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from 'reactflow';
import { Clock, Edit2, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, Button, Input } from '@caruso/ui';

export const DelayNode = memo(({ data, id }: NodeProps) => {
  const { deleteElements } = useReactFlow();
  const [isEditing, setIsEditing] = useState(false);
  const [delay, setDelay] = useState(data.delay || 5);

  const handleSave = () => {
    data.delay = parseInt(delay.toString());
    setIsEditing(false);
  };

  const handleCancel = () => {
    setDelay(data.delay || 5);
    setIsEditing(false);
  };

  const handleDelete = () => {
    deleteElements({ nodes: [{ id }] });
  };

  return (
    <>
      <div className="bg-neutral-900 border-2 border-blue-500/40 rounded-lg p-4 min-w-[200px] shadow-lg">
        <Handle type="target" position={Position.Top} className="w-3 h-3 !bg-blue-500" />

        <div className="flex items-center gap-2 mb-3">
          <Clock className="w-5 h-5 text-blue-400" />
          <span className="font-bold text-white">Aguardar</span>
          <div className="ml-auto flex items-center gap-1">
            <button
              onClick={() => setIsEditing(true)}
              className="text-blue-400 hover:text-white transition-colors p-1"
              title="Editar delay"
            >
              <Edit2 className="w-4 h-4" />
            </button>
            <button
              onClick={handleDelete}
              className="text-red-400 hover:text-red-300 transition-colors p-1"
              title="Deletar nó"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="text-center">
          <div className="text-3xl font-bold text-blue-400">{delay}</div>
          <div className="text-xs text-brand-ivory/60 mt-1">segundos</div>
        </div>

        <Handle type="source" position={Position.Bottom} className="w-3 h-3 !bg-blue-500" />
      </div>

      <Dialog open={isEditing} onOpenChange={setIsEditing}>
        <DialogContent className="bg-neutral-900 border-brand-gold/20 text-white">
          <DialogHeader>
            <DialogTitle className="text-white flex items-center gap-2">
              <Clock className="w-5 h-5 text-blue-400" />
              Aguardar
            </DialogTitle>
            <DialogDescription className="text-brand-ivory/70">
              Defina quanto tempo aguardar antes de continuar o fluxo
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 mt-4">
            <div>
              <label className="block text-sm font-medium text-brand-ivory mb-2">
                Tempo (segundos)
              </label>
              <Input
                type="number"
                value={delay}
                onChange={(e) => setDelay(parseInt(e.target.value) || 1)}
                min="1"
                className="bg-neutral-800/50 border-neutral-700 text-white"
                autoFocus
              />
            </div>
            <div className="flex gap-2 justify-end">
              <Button
                onClick={handleCancel}
                variant="outline"
                className="border-neutral-700 text-white hover:bg-neutral-800"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleSave}
                className="bg-brand-gold hover:bg-brand-gold/90 text-brand-ink font-semibold"
              >
                Salvar
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
});

DelayNode.displayName = 'DelayNode';
